import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PublicLayout from "@/components/layout/PublicLayout";
import SEO from "@/components/SEO";
import { Reveal, Icon } from "@/components/motion";
import { api } from "@/lib/api";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <PublicLayout>
      <SEO title="YouTube Marketing Services | NewStarAds"
        description="Explore NewStarAds YouTube marketing services: video promotion, ads management, channel promotion, audience targeting, SEO consulting and transparent analytics reporting." />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8">
        <Reveal>
          <p className="text-xs uppercase tracking-widest font-semibold text-primary">Services</p>
          <h1 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter">Everything you need to grow on YouTube</h1>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl">Compliant, transparent services designed for creators and businesses. We clearly distinguish paid promotion from organic results — and never promise guaranteed views.</p>
        </Reveal>
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((s, i) => (
          <Reveal key={s.slug} delay={(i % 3) * 0.05}>
            <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`}
              className="group flex flex-col h-full rounded-2xl border border-slate-200 bg-white p-7 transition-all hover:-translate-y-1 hover:shadow-xl hover:border-primary/30">
              <div className="w-11 h-11 grid place-items-center rounded-xl bg-primary/10 text-primary mb-5"><Icon name={s.icon} className="w-6 h-6" /></div>
              <h3 className="font-display text-xl font-bold tracking-tight">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{s.short}</p>
              <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary">Explore <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
            </Link>
          </Reveal>
        ))}
      </section>
    </PublicLayout>
  );
}
